enum TransportTypes {
    WALK = 'walk',
    BIKE = 'bike',
    MOTORBIKE = 'motorbike',
    CAR = 'car',
    CARGOBIKE = 'cargobike',
    VAN = 'van',
    CARGOBIKEXL = 'cargobikexl',
    MOTORBIKEXL = 'motorbikexl',
    STEERWAGON = 'steerwagon',
    TRUCK = 'truck',
    TRAILERBIKE = 'trailerbike',
}

export default TransportTypes;
